import { useMutation, useQuery } from 'react-query'
import {
  clickAppOnboardingNotification,
  closeAppOnboardingNotification,
  getAppOnboardingNotification,
} from 'utils/apis/appOnboardingNotification'

export function useGetAppOnboardingNotification(options = {}) {
  return useQuery(
    ['appOnboardingNotification'],
    async () => {
      const {
        data: { data },
      } = await getAppOnboardingNotification()

      return data
    },
    options,
  )
}

export const useCloseAppOnboardingNotification = () => {
  return useMutation(closeAppOnboardingNotification)
}

export const useClickAppOnboardingNotification = () => {
  return useMutation(clickAppOnboardingNotification)
}
